<template>
  <b-row id="children-list">
    <ChildCard
      v-for="(child, index) in list"
      :key="index"
      :item="child"
      class="list-complete-item"
      :loader="getLoader && !moreSpinner"
    ></ChildCard>
    <div v-if="(emptyList && getLoader) || initLoader || moreSpinner" class="row px-3">
      <ChildCard
        v-for="item in emptyList && !initLoader ? 4 : 6"
        :key="`loader${item}`"
        :loader="true"
        :item="listChild"
      ></ChildCard>
    </div>
    <b-col v-if="emptyList && !initLoader && !getLoader" cols="12" class="mb-3">
      <div class="border border-3 border-blue-50 rounded-sm d-flex align-items-center px-5 py-4">
        <img :src="emptyListChildrenImage" alt="Brak wynikow" class="mr-3" />
        <div class="text-lg text-blue-500">
          {{ $t('childrenList.emptyList') }}
          <a @click.prevent="removeAllFilters" href="#">
            {{ $t('childrenList.emptyListLink') }}
            <b-spinner
              v-if="getLoader"
              variant="primary"
              small
              style="margin-bottom: 3px"
            ></b-spinner> </a
          >.
        </div>
      </div>
    </b-col>
    <b-col cols="12">
      <b-button
        id="swd_more-kids-button"
        v-if="isButtonDisabled"
        @click="showMore"
        class="px-5 py-3 mt-2 mb-4 mx-auto d-block text-md font-weight-bold btn-lh angle-right-icon-hower"
        variant="outline-primary rounded"
        :disabled="getLoader"
        size="lg"
      >
        {{ $t('childrenList.showMoreChildren') }}
        <i class="angle-right-icon ml-1 bg-blue"></i>
        <b-spinner v-if="getLoader" small class="ml-2"></b-spinner>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import ChildCard from '@/components/childrenList/ChildCard.vue'
import { child as listChild } from '@/constants/loaderChild'

export default {
  name: 'ChildrenList',
  components: { ChildCard },
  props: {
    initLoader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moreSpinner: false,
      listChild,
      emptyListChildrenImage: new URL('/src/assets/svg/emptyListChildren.svg', import.meta.url).href
    }
  },
  computed: {
    getChildrenList() {
      return this.$store.getters['filter/getChildrenList']
    },
    childrenAmount() {
      return this.getChildrenList.number
    },
    highlighted() {
      return this.getChildrenList && this.getChildrenList.highlighted
    },
    regular() {
      return this.getChildrenList && this.getChildrenList.regular
    },
    list() {
      return this.highlighted.concat(this.regular)
    },
    pagination() {
      return this.$store.getters['filter/getPagination']
    },
    isButtonDisabled() {
      const pageMaxAmount = this.pagination.offset + this.pagination.limit
      return pageMaxAmount < this.childrenAmount
    },
    emptyList() {
      return this.childrenAmount === 0
    },
    getLoader() {
      return this.$store.getters['filter/getLoader']
    }
  },
  methods: {
    showMore() {
      this.moreSpinner = true
      this.$store.commit('filter/setPagination', {
        path: 'offset',
        value: this.pagination.offset + this.pagination.limit
      })
      this.$store.dispatch('filter/getFilter').finally(() => {
        this.moreSpinner = false
      })
    },
    removeAllFilters() {
      if (this.getLoader) {
        return
      }
      this.$store.commit('filter/setParameters')
      this.$store.commit('filter/setPagination', {
        path: 'offset',
        value: 0
      })
      this.$store.dispatch('filter/getFilter')
    }
  }
}
</script>

<style scoped>
.btn-lh {
  line-height: 1.6;
}
</style>
